import { WalletTypes } from '@rango-dev/provider-all';
import { Networks } from '@rango-dev/widget-embedded';
export const BLOCKCHAINS_THAT_SUPPORT_PROFILE = [Networks.ETHEREUM, Networks.SOLANA];
export const WALLETS_WITHOUT_SIGN_MESSAGE_METHOD = [WalletTypes.SAFE];
